import {
  AbwesenheitsStation,
  ArbeitsbereichStation,
} from '@/domain/mitarbeiter/features/rotationsplan/entities/Station';

export class Abschnitt {
  constructor({
    id,
    name,
    stationen,
    position,
  }: {
    id: string;
    name: string;
    stationen: (ArbeitsbereichStation | AbwesenheitsStation)[];
    position: number;
  }) {
    this.id = id;
    this.name = name;
    this.stationen = stationen;
    this.position = position;
  }

  id: string;
  name: string;
  stationen: (ArbeitsbereichStation | AbwesenheitsStation)[];
  position: number;
}
